module.exports = __webpack_public_path__ + "img/cbd3blur.102c37f1.jpg";